import PropTypes from 'prop-types';

const Spinner = ({ size = 'sm', overlay = false, children }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-16 h-16',
    lg: 'w-24 h-24'
  };

  const spinnerClass = `
    border-4 
    border-t-4 
    border-secondary
    border-t-primary-light
    rounded-full 
    animate-spin
    ${sizeClasses[size]}
  `.trim();

  if (!overlay) {
    return (
      <div className="flex flex-col items-center justify-center w-full h-full">
        <div className={spinnerClass} />
        {children && <div>{children}</div>}
      </div>
    );
  }
  
  return (
    <div className={`${overlay ? 'text-white' : ''} fixed inset-0 flex flex-col items-center justify-center z-50 bg-black bg-opacity-50 w-full h-full`}>
      <div className={spinnerClass} />
        {children && <div>{children}</div>}
    </div>
  );
};

// PropTypes for type checking
Spinner.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  overlay: PropTypes.bool
};

export default Spinner;